var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-switch',{on:{"click":_vm.checkVersion},model:{value:(_vm.experimentalEnabled),callback:function ($$v) {_vm.experimentalEnabled=$$v},expression:"experimentalEnabled"}})
}
var staticRenderFns = []

export { render, staticRenderFns }